import {GenericInput, GenericSelect} from '@hm/fundamental'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {Option} from '../../../common/AutoSelectDropdown'
import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {UserInformationProps} from './types'

type UserOrgUnitInputProps<T extends FieldValues> = UserInformationProps<T> & {
  primaryOrgUnitsMarketsSelectValues: Option[]
  primaryOrganisationalUnitLabel?: string | null
}

export const UserOrgUnitInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  primaryOrganisationalUnitLabel,
  primaryOrgUnitsMarketsSelectValues,
  isLoading,
  name
}: UserOrgUnitInputProps<T>) => {
  const {t} = useTranslation()
  const values = formMethods.watch()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <>
      {readonlyMode ? (
        <GenericInput
          label={t('userInformationForm.primaryOrganisationalUnit')}
          value={primaryOrganisationalUnitLabel || '-'}
          isReadOnly={true}
        />
      ) : (
        primaryOrgUnitsMarketsSelectValues.length > 0 && (
          <Controller
            name={name}
            control={formMethods.control}
            render={({field, fieldState}) => (
              <GenericSelect
                {...field}
                setValue={(value) => field.onChange(value)}
                data-cy={`userInformationForm-${field.name}`}
                scrollable={true}
                label={t('userInformationForm.primaryOrganisationalUnit')}
                isReadOnly={readonlyMode}
                isTouched={fieldState.isTouched}
                error={!values.country ? t('userInformationForm.brandingHelperText') : ''}
                values={primaryOrgUnitsMarketsSelectValues}
                className="w-full"
              />
            )}
          />
        )
      )}
    </>
  )
}
